import styled from "styled-components";

export const Wrap = styled.div`
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  user-select: none;
  right: 20px;
  bottom: 78px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Campaign = styled.div`
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #004cad;
  padding: 4px 8px;
`;

export const Name = styled.div`
  font-size: 10px;
  line-height: 1.2;
`;

export const Variation = styled.div`
  font-size: 9px;
  line-height: 1;
`;
